import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Importando o JS do Bootstrap
import CustomPagination from "../util/CustomPagination";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import Swal from "sweetalert2";

require("./assets/css/Department.css");

const DepartmentValueModal = ({show, handleClose, department}) => {

    const [value, setValue] = useState(null);
    const [loadingSave, setLoadingSave] = useState(null);
    const save = () => {
        setLoadingSave(true)
      console.log(department);

        ApiService.send("put", process.env.REACT_APP_URL_API + "departments/update-value",
            {
                department_id: department.id,
                value: value
            }, false)
            .then((res) => {

                department.value = value ;

                Swal.fire("Sucesso", "Valor salvo com sucesso!", "success").then(() => {
                    handleClose(true, department);
                });
            })
            .catch((error) => {
                ApiService.handleApiError(error);
            }).finally(
                setLoadingSave(false)
        );

    };

    // Quando o modal for exibido, tenta carregar os hospitais do localStorage
    useEffect(() => {
        if (department) {
            setValue(department.value ?? 0);
        } else {
            setValue(0);
        }
    }, [department]);

    return (
        <Modal show={show} onHide={handleClose} centered size="lg"   onExited={() => {
            setValue(null);
            setLoadingSave(false);
        }}>
            <Modal.Header closeButton>
                <Modal.Title>{department?.hospital?.name} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row mb-3">
                    <label>Valor Hora</label>
                    <div className="col-12">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Valor"
                            onChange={(e) => setValue(e.target.value)}
                            value={value}
                        />
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary"  onClick={() =>handleClose()}>
                    <i className="fa fa-close me-1"></i> Cancelar
                </Button>
                <Button variant="primary"  onClick={() =>save()} disabled={loadingSave}>
                    {loadingSave ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"
                                  aria-hidden="true"></span>
                            Salvando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-save me-1"></i> Salvar
                        </>
                    )}
                </Button>

            </Modal.Footer>
        </Modal>
    )
        ;
};

export default DepartmentValueModal;
